import {
  ActionRequiredNotificationBase,
  ActionRequiredAlertService,
  ActionRequiredNotification
} from "./action-required-alert-service";
import { AudioService } from "./audio-service";
import { WindowCommunicationBridgeService } from "../../ShellCommon/eventModule/window-communication-bridge";
import { AlertAction } from "../../ShellCommon/Controls/alert/alert";
import { MsalAuthenticationServiceImplementation } from "../../ServiceDesk/sdServices/msal/msal-authentication-service";

export const legacyShowActionRequiredNotificationEventName = "ShowNotification";
export const legacyHideActionRequiredNotificationEventName = "HideNotification";

interface ActionRequiredNotificationLegacy extends ActionRequiredNotificationBase {
  actions: LegacyAction[];
  notificationSoundKey?: string;
}

interface LegacyAction {
  eventName: string;
  params: any;
  displayName: string;
}

interface AlertEventData {
  eventName: string;
  eventParams: any;
}

export class LegacyActionRequiredAlertService {
  // @ngInject
  constructor(
    private windowCommunicationBridgeService: WindowCommunicationBridgeService,
    private $rootScope: ng.IRootScopeService,
    private audioService: AudioService,
    private $state: angular.ui.IStateService,
    private msalAuthenticationService: MsalAuthenticationServiceImplementation,
    private actionRequiredAlertService: ActionRequiredAlertService
  ) {
    let showNotificationEventWrapper = (notification: ActionRequiredNotification) => {
      this.showAlertInternal(notification);
    };
    let hideNotificationEventWrapper = (params: any) => {
      if (params.notificationId) {
        this.actionRequiredAlertService.hideAlert(params.notificationId);
      }
    };
    windowCommunicationBridgeService.subscribe(
      legacyShowActionRequiredNotificationEventName,
      showNotificationEventWrapper.bind(this),
      $rootScope
    );
    windowCommunicationBridgeService.subscribe(
      legacyHideActionRequiredNotificationEventName,
      hideNotificationEventWrapper.bind(this),
      $rootScope
    );
  }

  private showAlertInternal(notificationParam: ActionRequiredNotification | ActionRequiredNotificationLegacy) {
    let notification: ActionRequiredNotification = notificationParam as ActionRequiredNotification;
    let legacyNotification: ActionRequiredNotificationLegacy = notificationParam as ActionRequiredNotificationLegacy;
    notification.actions = this.convertLegacyActionToAlertAction(legacyNotification.actions, legacyNotification);
    this.handleLegacySoundPreference(legacyNotification.notificationSoundKey);
    notification.glyph = "sd-glyph-chat";
    this.actionRequiredAlertService.showAlert(notification);
  }

  private handleLegacySoundPreference(notificationSoundKey: string) {
    if (
      this.$state &&
      this.$state.current &&
      this.$state.current.name &&
      this.$state.current.name.toLowerCase() == "comm"
    ) {
      if (
        this.msalAuthenticationService &&
        this.msalAuthenticationService.userInfo &&
        this.msalAuthenticationService.userInfo.isAuthenticated
      ) {
        this.audioService.playPreference(notificationSoundKey || "newchatrequestsound", "Comm");
      }
    }
  }

  private convertLegacyActionToAlertAction(actions: LegacyAction[], notification: ActionRequiredNotificationLegacy) {
    let alertActions: AlertAction[] = [];
    if (actions) {
      alertActions = [];
      actions.forEach((action: LegacyAction) => {
        let alertEventData: AlertEventData = { eventName: action.eventName, eventParams: action.params };
        let callback = () => {
          this.legacyActionPerformed(alertEventData, notification);
        };
        let alertAction: AlertAction = { linkText: action.displayName, callback: callback.bind(this) };
        alertActions.push(alertAction);
      });
    }
    return alertActions;
  }

  private legacyActionPerformed(actionEvent: AlertEventData, notification: ActionRequiredNotificationLegacy) {
    if (actionEvent && actionEvent.eventName) {
      this.windowCommunicationBridgeService.publish(actionEvent.eventName, actionEvent.eventParams);
    }
    this.actionRequiredAlertService.hideAlert(notification.notificationId);
  }
}
